import React from 'react';
import { FaGithub } from 'react-icons/fa';
import { HiArrowRight } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import useTilt from '../../../hooks/useTilt';
import Reveal from '../../helper/reveal';
import './single-project.css';

function SingleProjectUI({ id, index = 0, name, desc, tags = [], code, slug, headingLevel = 3, printOnly = false }) {
  const Heading = `h${headingLevel}`;
  const number = String(index + 1).padStart(2, '0');
  const tiltRef = useTilt(4);

  return (
    <Reveal as='article' delay={(index % 2) * 90} className={`project${printOnly ? ' project--print-only' : ''}`} aria-labelledby={`project-${id}`}>
      <div ref={tiltRef} className='project__card'>
        <span className='project__index' aria-hidden='true'>{number}</span>
        <Heading id={`project-${id}`} className='project__title'>{name}</Heading>
        <p className='project__desc'>{desc}</p>

        {tags.length > 0 && (
          <ul className='project__tags' aria-label='Technologies'>
            {tags.map((tag) => (
              <li key={tag} className='chip'>{tag}</li>
            ))}
          </ul>
        )}

        {slug && (
          <Link className='project__link project__details' to={`/projects/${slug}`} aria-label={`${name}: view details`}>
            Details <HiArrowRight aria-hidden='true' />
          </Link>
        )}

        {code && (
          <a
            className='project__link'
            href={code}
            target='_blank'
            rel='noreferrer'
            aria-label={`${name}: source code on GitHub (opens in a new tab)`}
          >
            <FaGithub aria-hidden='true' /> Source code
          </a>
        )}
      </div>
    </Reveal>
  );
}

export default SingleProjectUI;
